import React from 'react';
import Signup from './signup';
import {inject, observer} from 'mobx-react';
import '../../../styles/login.css';
import PropTypes from 'prop-types';
import Modal from 'react-bulma-components/lib/components/modal';
import Image from 'react-bulma-components/lib/components/image';
import Button from 'react-bulma-components/lib/components/button';
import Section from 'react-bulma-components/lib/components/section';
import superagentPromise from 'superagent-promise';
import _superagent from 'superagent';
// let _login = false
import {Redirect, withRouter} from 'react-router-dom';
// import UserStore from '../../stores/userStore';
// import LandingPage from './landingPage';
import {Label} from 'react-bulma-components/lib/components/form';
import SocialButton from './socialLogin';
import ChangePWDSecurity from '../onboarding/resetPassword/changePWDSecurity';
import {validateIfInputIsEmail} from '../../../helpers/validationChecks';
import {fb_code, google_id} from '../../../env/index';
import ReactGA from "react-ga";
// import SimpleCrypto from "simple-crypto-js";
const imagesPath = {
    unchecked: require('../../../assets/unchecked.png'),
    checked: require('../../../assets/checked.png'),
    hidePasswordImg: require('../../../assets/hide-password.png'),
    showPasswordImg: require('../../../assets/show-password.png')
}
const superagent = superagentPromise(_superagent, global.Promise);
var encryptedPwd = "";
var decryptedPwd = "";

@inject('authStore', 'userStore', 'navigatorStore')
@withRouter
@observer
export default class login extends React.Component {

    static propTypes = {
        Modal: PropTypes.object,
    };
    static defaultProps = {
        Modal: {},
    };
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            login_: false,
            loginFailMsg: "",
            rememberMe: false,
            validateForm: "none",
            verified: false,
            showSignUpModal: false,
            showSigninModal: true,
            email: "",
            password: "",
            forgotPW: false,
            hiddenPassword: true
        };
        this.imagePreviewCanvasRef = React.createRef()
    }


    toggleShowPassword() {
        this.setState({hiddenPassword: !this.state.hiddenPassword});
    }

    handleSocialLoginFacebook(user) {
        // console.log("success =", user);
        var formData = new FormData();
        var _scope = this;
        formData.append('fb_id', user._profile.id);
        localStorage.setItem("fb_id", user._profile.id)
        localStorage.setItem("fb_email", user._profile.email)
        this.props.authStore.socialLogin(formData, user._profile.id)

            .then((response) => {


                if (
                    !window.location.href.includes("artworks") &&
                    !window.location.href.includes("artist") &&
                    !window.location.href.includes("category") &&
                    !window.location.href.includes("product") &&
                    !window.location.href.includes("profile") &&
                    !window.location.href.includes("search") &&
                    !window.location.href.includes("details") &&
                    !window.location.href.includes("edit") &&
                    !window.location.href.includes("onboarding")

                ) {
                    // console.log("receive i am doing my job")
                    this.props.history.replace('/')
                };
                if (window.location.href.includes("profile/details") || window.location.href.includes("product/details")) {
                    // console.log("receive i am doing my job")
                    window.location.reload()
                }
                // console.log("this.props.userStore.loginDone", this.props.userStore.loginDone),
                // console.log("[response in login]", response),
                this.props.navigatorStore.closeSignInModal(),
                    this.props.navigatorStore.closeSignUpModal(),
                    this.props.authStore.resetOnboardingStatuses("onboardingThreeIncomplete");
                window.scrollTo({ top: 0, behavior: 'smooth' })

                // this.props.history.replace('/')
                //     ,
                ReactGA.pageview('/Facebook login');
                //console.log("this.props.userStore.loginDone", this.props.userStore.loginDone),
                //console.log("[response in login]", response),
                this.props.navigatorStore.closeSignInModal(),
                    this.props.navigatorStore.closeSignUpModal(),
                    // window.location.reload();
                    localStorage.setItem("image", `http://graph.facebook.com/${user._profile.id}/picture?type=large`)
                var facebook_profile_picture = `http://graph.facebook.com/${user._profile.id}/picture?type=large`
                this.props.userStore.pulluser()
                    .then(res => {
                        console.log(res)
                        if (!res.data[0].image_uploaded) {
                            // console.log(typeof (`http://graph.facebook.com/${user._profile.id}/picture?type=large`));
                            // superagent
                            //     .get(`http://graph.facebook.com/${user._profile.id}/picture?type=large`)
                            //     .then((res)=>{
                            //         console.log(res)
                            //         var blob = res
                            //         var uInt8Array = new Uint8Array(res);
                            //         var i = uInt8Array.length;
                            //         var binaryString = new Array(i);
                            //         while (i--)
                            //         {
                            //           binaryString[i] = String.fromCharCode(uInt8Array[i]);
                            //         }
                            //         var data = binaryString.join('');

                            //         var formData = new FormData();
                            //         console.log(data);
                            //         // formData.append("image", data, "myFile.png"); 
                            //         // this.props.userStore.requestToEditUser(formData, null, true)
                            //         // .then((response) => {
                            //         //     console.log("[changed the propic]", response)

                            //         // })
                            //     })
                            var formData1 = new FormData();
                            fetch(facebook_profile_picture)
                                .then(function (response) {
                                    return response.blob()
                                })
                                .then(function (blob) {
                                    // here the image is a blob
                                    console.log(blob);
                                         formData1.append("image", blob, "myFile.png"); 
                                         _scope.props.userStore.requestToEditUser(formData1, null, false)
                                      .then((response) => {
                                         console.log("[changed the propic]", response)

                                      })
                                });
                        }
                    })
            }
            )


    }
    handleSocialLoginGoogle(user) {
        console.log("success =", user);
        var formData = new FormData();
        formData.append('goog_id', user._profile.id);
        this.props.authStore.socialLogin(formData)
            .then(() => this.props.userStore.pulluser())
            .then((response) => {
                ReactGA.pageview('/Google login')
                if (
                    !window.location.href.includes("artworks") &&
                    !window.location.href.includes("artist") &&
                    !window.location.href.includes("category") &&
                    !window.location.href.includes("product") &&
                    !window.location.href.includes("profile") &&
                    !window.location.href.includes("search") &&
                    !window.location.href.includes("details") &&
                    !window.location.href.includes("edit") &&
                    !window.location.href.includes("onboarding")

                ) {
                    // console.log("receive i am doing my job")
                    this.props.history.replace('/')
                };
                if (window.location.href.includes("profile/details") || window.location.href.includes("product/details")) {
                    // console.log("receive i am doing my job")
                    window.location.reload()
                }
                // console.log("this.props.userStore.loginDone", this.props.userStore.loginDone),
                // console.log("[response in login]", response),
                this.props.navigatorStore.closeSignInModal(),
                    this.props.navigatorStore.closeSignUpModal(),
                    this.props.authStore.resetOnboardingStatuses("onboardingThreeIncomplete");
                window.scrollTo({ top: 0, behavior: 'smooth' })
                // this.props.history.replace('/')
                //     ,
                // console.log("this.props.userStore.loginDone", this.props.userStore.loginDone),
                // console.log("[response in login]", response),
                // this.props.navigatorStore.closeSignInModal(),
                // this.props.navigatorStore.closeSignUpModal()
                // window.location.reload();
                var formData1 = new FormData();
                var _scope = this;
                fetch(user._profile.profilePicURL)
                .then(function (response) {
                    return response.blob()
                })
                .then(function (blob) {
                    // here the image is a blob
                    console.log(blob);
                         formData1.append("image", blob, "myFile.png"); 
                         _scope.props.userStore.requestToEditUser(formData1, null, false)
                      .then((response) => {
                         console.log("[changed the propic]", response)

                      })
                });
                localStorage.setItem("goog_id", user._profile.id)
                localStorage.setItem("goog_email", user._profile.email)
            }
            )


    }

    handleSocialLoginFailure = (err) => {
        // console.log("handleSocialLoginFailure", err)
    }
    onChecked() {
        this.props.authStore.setRememberMe();
        // console.log("checked")
        this.setState({
            rememberMe: !this.state.rememberMe
        })
    }
    onValuChangedEmail(event) {
        this.setState({
            email: event.target.value
        })
        this.props.authStore.setEmail(event.target.value);
    }
    onValuChangedPassword(event) {
        this.setState({
            password: event.target.value
        })
        this.props.authStore.setPassword(event.target.value);
    }

    // validationChecks() {
    //     let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    //     if(this.state.email= 0 || this.state.password <8){
    //         return "Please provide credentials";
    //     }
    //     if ( re.test(this.state.email) ) {
    //         return true
    //     }
    //     else return "Value for 'email' should be of type email"
    //         }

    onSubmit = (e) => {
        e.preventDefault()
        if (this.state.email.length == 0) {
            this.props.navigatorStore.openErrorModal("Please enter a valid email");
            return;

        }
        if (!!this.state.email && !validateIfInputIsEmail(this.state.email)) {
            this.props.navigatorStore.openErrorModal("Please enter a valid email");
            return;
        }

        if (this.state.password.length == 0) {
            this.props.navigatorStore.openErrorModal("Please enter your password");
            return;
        }

        /*if (this.state.password.length == 0) {
            this.props.navigatorStore.openErrorModal("Please enter your password");
            return;
        }
        if (this.state.password.length < 6) {
            this.props.navigatorStore.openErrorModal("Password must have a minimum of 6 characters");
            return;
        }
        if (this.state.password && !validateIfInputHasSpaces(this.state.password)) {
            this.props.navigatorStore.openErrorModal("Password must not contain any space");
            return;
        }*/

        if (this.state.rememberMe) {
            localStorage.setItem("remembered_email", this.state.email);
            //  encryptedPwd = SimpleCrypto.encrypt(this.state.password);
            // // console.log("encrypted",SimpleCrypto.encrypt(this.state.password));
            //  decryptedPwd = SimpleCrypto.decrypt(this.state.password);
            //  // console.log("encrypted",SimpleCrypto.decrypt(this.state.password))

        }

        // const validated = this.validationChecks()
        this.props.authStore.login()
            .then(() => this.props.userStore.pulluser())
            .then((response) => {
                localStorage.setItem("login_email", this.state.email)
                // console.log("// console.log", response)
                // console.log("receive", window.location.href);
                ReactGA.pageview('/Login action');
                if (
                    !window.location.href.includes("artworks") &&
                    !window.location.href.includes("artist") &&
                    !window.location.href.includes("category") &&
                    !window.location.href.includes("product") &&
                    !window.location.href.includes("profile") &&
                    !window.location.href.includes("search") &&
                    !window.location.href.includes("details") &&
                    !window.location.href.includes("edit") &&
                    !window.location.href.includes("onboarding")

                ) {
                    // console.log("receive i am doing my job")
                    this.props.history.replace('/')
                };
                if (window.location.href.includes("profile/details") || window.location.href.includes("product/details")) {
                    // console.log("receive i am doing my job")
                    window.location.reload()
                }
                // console.log("this.props.userStore.loginDone", this.props.userStore.loginDone),
                // console.log("[response in login]", response),
                this.props.navigatorStore.closeSignInModal(),
                    this.props.navigatorStore.closeSignUpModal(),
                    this.props.authStore.resetOnboardingStatuses("onboardingThreeIncomplete");
                window.scrollTo({ top: 0, behavior: 'smooth' })
            }
            )



    };
    // var self = this
    // if (this.state.credentials.email.length > 0 && this.state.credentials.password.length > 0) {
    //     // console.log("form data", this.state.credentials, this.state.rememberMe);

    //     // console.log("submit request valid");
    //     superagent
    //         .post('https://yourmasterpieces.in/ArticanYMP/v2.0/login')
    //         .send({ email: this.state.credentials.email, password: this.state.credentials.password, login_type: 'email' })
    //         .set('Content-Type', 'application/x-www-form-urlencoded')
    //         .end(function (error, response) {
    //             if (error) {
    //                 // console.log("Error: " + error);
    //                   this.props.navigatorStore.openErrorModal("error occured : ", error)
    //                 return;

    //             }

    //             // console.log("bodyyy", response.body, "for request");
    //             if (!response.body.error) {
    //                 _login = !response.body.error
    //                   this.props.navigatorStore.openErrorModal("login successfull")
    //                 self.setState({ login_: true });
    //             }
    //             else   this.props.navigatorStore.openErrorModal(response.body.message)
    //         });

    //     else   this.props.navigatorStore.openErrorModal("please fill out creds");
    // }


    open() {
        console.log("signInModal open function")
        this.props.navigatorStore.openSignInModal();
        ReactGA.pageview('/Login screen');
    };
    close() {


        // if (window.location.href.includes("profile/details") || window.location.href.includes("product/details")) {
        //     this.setState({
        //         navtoHome: true
        // console.log("receive i am doing my job",window.location.href)
        //     })
        // }
        if (
            window.location.href.includes("artworks") ||
            window.location.href.includes("artists") 
            // !window.location.href.includes("category") &&
            // !window.location.href.includes("product") &&
            // !window.location.href.includes("profile") &&
            // !window.location.href.includes("search") &&
            // !window.location.href.includes("details") &&
            // !window.location.href.includes("edit") &&
            // !window.location.href.includes("onboarding")

        ) {
            // console.log("receive i am doing my job")
            this.props.history.replace('/')
        };
        this.props.navigatorStore.closeSignInModal()
    };


    showAccount() {
        this.props.navigatorStore.openSignUpModal()
        ReactGA.pageview('/SignUp screen');
    }
    showSignInModal() {
        this.setState({
            showSignInModal: true,
            show: true,
            showSignUpModal: false
        })
    }


    handleForgotPassword() {
        this.props.navigatorStore.closeSignInModal()
        this.setState({
            forgotPW: true
        })
        ReactGA.pageview('/Forgot password');
    }
    getImageNameRememberMe = () => this.state.rememberMe ? 'checked' : 'unchecked'
    render() {

        const imageNameRem = this.getImageNameRememberMe();
        if (this.props.navigatorStore.changePasswordForSecurity) {
            return <ChangePWDSecurity />
        }
        // if(this.state.forgotPW){
        //     return(
        //         <Redirect push to='/forgotpw' ></Redirect>
        //     )
        // }
        if (!this.props.userStore.currentUser) {



            // if (this.state.navtoHome) {
            //     return (
            //         <Redirect push to=""></Redirect>
            //     )
            // }

            return (
                <div style={{
                    margin: "0 auto"
                }}>
                    <canvas style={{ display: "none" }} ref={this.imagePreviewCanvasRef}></canvas>
                    {/* <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/bulma/0.7.2/css/bulma.min.css"></link> */}
                    <Button onClick={this.open.bind(this)} className="masterpieces-primary-buttons header-login-button">LOGIN & SIGNUP</Button>
                    {this.state.navtoHome && <Redirect push to=""></Redirect>}
                    <LoginModal show={this.props.navigatorStore.showSignInModal}
                                close={this.close.bind(this)}
                                imageNameRem={imageNameRem}
                                onValuChangedEmail={this.onValuChangedEmail.bind(this)}
                                onValuChangedPassword={this.onValuChangedPassword.bind(this)}
                                showAccount={this.showAccount.bind(this)}
                                onChecked={this.onChecked.bind(this)}
                                onSubmit={this.onSubmit.bind(this)}
                                handleSocialLoginFacebook={this.handleSocialLoginFacebook.bind(this)}
                                handleSocialLoginGoogle={this.handleSocialLoginGoogle.bind(this)}
                                handleSocialLoginFailure={this.handleSocialLoginFailure.bind(this)}
                                handleForgotPassword={this.handleForgotPassword.bind(this)}
                                navtoHome={this.state.navtoHome}
                                hiddenPassword={this.state.hiddenPassword}
                                toggleShowPassword={this.toggleShowPassword.bind(this)}

                    />

                    <Signup />
                    {this.state.forgotPW && <Redirect push to='/forgotpassword' />}
                </div>
            );
        }

        return (<span></span>)


    }
}
// }


export const LoginModal = (props) => {
    return (

            <Modal show={props.show} onClose={props.close} className="login-modal-layout is-active">
                {/* {this.props.children} */}
                <Modal.Content style={{zIndex: "97"}}>
                    <Section style={{backgroundColor: 'white', padding: "none"}} className="mymodal signModal">
                        <div className="myimage">

                            <a href="https://apps.apple.com/in/app/masterpiece-platform-for-non/id1089890769"
                               target="_blank">
                                <div className="ios-store">
                                    <img src={require('../../../assets/ios_app.png')} className="icon-image"/>
                                </div>
                            </a>
                            <a href="https://play.google.com/store/apps/details?id=com.codon.masterpiece&hl=en"
                               target="_blank">
                                <div className="playstore-icon">
                                    <img src={require('../../../assets/android_app.png')} className="icon-image"/>
                                </div>
                            </a>

                        </div>
                        <form className="myform">
                            <div style={{textAlign: "left"}} className="log-in">Log In
                                <img onClick={props.close} className="cross-icon-for-masterpieces-modal"
                                     src={require('../../../assets/cross_icon_for_close.png')}></img>
                            </div>
                            <div className="ruling-forgot-password-section"></div>
                            <Label className="mb-15">
                                <p className="label label-text">EMAIL</p>
                                <input className="input-rectangle" type="text" name="email" placeholder="Your Email"
                                       onChange={props.onValuChangedEmail}/>
                            </Label>
                            <Label className="mb-15">
                                <p className="label label-text">PASSWORD</p>
                                <div className="input-group show-hide-input-block">
                                    <input className="input-rectangle"
                                           name="password"
                                           type={(props.hiddenPassword) ? "password" : "text"}
                                           placeholder="Your Password" onChange={props.onValuChangedPassword}/>
                                    <div className="input-group-append login-input-group">
                                        <span className="input-group-text">
                                           <img
                                               src={(props.hiddenPassword) ? imagesPath.hidePasswordImg : imagesPath.showPasswordImg}
                                               className="show-password-image" onClick={props.toggleShowPassword}/>
                                        </span>
                                    </div>
                                </div>

                            </Label>
                            <div className="remember-me-and-login-section">
                                <div className="remember-me-section">
                                    {/* <img alt="" src={imagesPath[props.imageNameRem]} className="remember-me" name="rememberMe" onClick={props.onChecked} />
                                <p className="remember-me-text">REMEMBER ME</p>*/}
                                </div>
                                <div style={{
                                    flex: "1",
                                    marginLeft: "19%"
                                }}>
                                    <Button className="button-link-login" onClick={props.onSubmit} style={{
                                        backgroundColor: "#BEA57C",
                                        borderRadius: "unset",
                                        marginRight: "10px"
                                    }}><p className="button-name-login">LOG IN</p></Button></div>

                            </div>
                            <div className="ruling-forgot-password-section"></div>
                            <div style={{display: "flex", flex: 1}}>
                                <div style={{flex: "1"}}><Button onClick={props.handleForgotPassword}
                                                                 className="forgot-password"><p
                                    className="button-name">FORGOT PASSWORD?</p></Button></div>

                                <div style={{flex: "1"}}><Button className="forgot-password"
                                                                 onClick={props.showAccount}><p
                                    className="button-name">CREATE AN ACCOUNT</p></Button></div>
                            </div>
                            <div className="footer-social">
                                <div className="social" style={{flex: 1, padding: "3%"}}>
                                    <p className="social-platform-login">Log In with a social platform</p>
                                </div>
                                <div className="social-1" style={{flex: 1,}}>
                                    <SocialButton
                                        provider='google'
                                        appId={google_id}
                                        onLoginSuccess={props.handleSocialLoginGoogle}
                                        onLoginFailure={props.handleSocialLoginFailure}
                                        autoCleanUri={true}
                                    >
                                        <a href="#">
                                            <Image src={require('../../../assets/Google.png')}/>
                                        </a>
                                    </SocialButton>
                                </div>
                                <div className="social-1" style={{flex: 1,}}>
                                    <SocialButton
                                        provider='facebook'
                                        appId={fb_code}
                                        onLoginSuccess={props.handleSocialLoginFacebook}
                                        onLoginFailure={props.handleSocialLoginFailure}
                                    >
                                        <a href="#">
                                            <Image src={require('../../../assets/Facebook.png')}/>
                                        </a>
                                    </SocialButton>
                                </div>
                            </div>
                        </form>
                    </Section>
                </Modal.Content>

            </Modal>
    )
}




// WEBPACK FOOTER //
// ./src/components/Home/onboarding/login.js